export default __webpack_public_path__ + "static/media/sports (1).e80d5956.jpg";